import jQuery from 'jquery';
import 'jquery-ui';
import 'jquery-validation';
import "./railsujs_shared";
window.$ = window.jQuery = jQuery;
